module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep-f119d745ce7cafc8843a31e7ca461d69.wav";